export default __webpack_public_path__ + "static/sisLogo-653fb5fc5e8cb40cacb0513b98e3ae5c.png";